import React, { useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import MaterialUITextInput from "../TextFieldInput/MaterialUITextInput";
import "../../../src/theme/variables.scss";
import { PartFormData } from "../../Models/Orderpart";

interface OrderInputProps {
  rowId: number;
  index: number;
  isFirst: boolean;
  onValidityChange: (isValid: boolean) => void;
  onDataChange: (data: PartFormData) => void;
  initialData?: PartFormData;
}

export default function OrderInput({ 
  rowId, 
  index,
  isFirst,
  onValidityChange,
  onDataChange,
  initialData 
}: OrderInputProps) {
  const methods = useForm<PartFormData>({
    mode: "onChange"
  });

  // Initialize or reset form values
  useEffect(() => {
    methods.reset(initialData || {
      IPC: "",
      PartNumber: "",
      PartName: "",
      Quantity: ""
    });
  }, [rowId]); 


  useEffect(() => {
    const subscription = methods.watch((value) => {
      const debouncedUpdate = setTimeout(() => {
        onDataChange(value as PartFormData);
      }, 100);
      return () => clearTimeout(debouncedUpdate);
    });
    return () => subscription.unsubscribe();
  }, [methods.watch]);

  // Validity updates
  useEffect(() => {
    onValidityChange(methods.formState.isValid);
  }, [methods.formState.isValid]);

  return (
    <FormProvider {...methods}>
      <div className="order-parts-alignment">
        <MaterialUITextInput
          name="IPC"
          label="IPC (Optional)"
          id={`ipc-${rowId}`}
        />
        <MaterialUITextInput
          name="PartNumber"
          label="Part #"
          id={`partnum-${rowId}`}
          required
          requiredMessage="Part number is required"
        />
        <MaterialUITextInput
          name="PartName"
          label="Part name"
          id={`partname-${rowId}`}
          required
          requiredMessage="Part name is required"
        />
        <MaterialUITextInput
          name="Quantity"
          label="Qty"
          id={`qty-${rowId}`}
          required
          requiredMessage="required"
          type="number"
          inputProps={{ min: 0 }}
        />
      </div>
    </FormProvider>
  );
}
